export default __webpack_public_path__ + "static/media/kwik_white_bg_resized.bd8551a7.png";